module.exports = __webpack_public_path__ + "img/hamabe_icon.6839d3af.png";